
import { IsInt, Min, Max, IsDefined, IsString } from 'class-validator';
import { BaseDto } from './base.dto';

export class KerbCollectionDto extends BaseDto {
  @IsInt()
  @Min(1)
  @Max(2147483647)
  @IsDefined()
  orderId: number;

  @IsDefined()
  @IsString()
  registrationPlate: string;

  @IsDefined()
  @IsString()
  vehicleColor: string;

  @IsDefined()
  @IsString()
  vehicleMake: string;
}
